import { Box, Button, Typography } from '@mui/material';
import { primarySoft } from '../../../../../../theme';
import { PersonalField } from '../../../../../../hooks/Marketing';

interface PersonalFieldButtonsProps {
  fields: PersonalField[];
  onSelect: (anchor: string) => void;
}

function PersonalFieldButtons({ fields, onSelect }: PersonalFieldButtonsProps) {
  if (fields.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', fontSize: '0.82rem' }}>
        Aucun champ disponible dans cette catégorie.
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'text.secondary', fontSize: '0.72rem', letterSpacing: 0.4, textTransform: 'uppercase', fontWeight: 600 }}>
        Champs disponibles
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {fields.map(field => (
          <Button
            key={field.ANCHOR}
            variant="outlined"
            size="small"
            onClick={() => onSelect(field.ANCHOR)}
            sx={{
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.8rem',
              borderRadius: 5,
              borderColor: theme => primarySoft(theme, 0.31),
              color: 'grey.800',
              backgroundColor: 'background.paper',
              px: 1.5,
              py: 0.4,
              '&:hover': { borderColor: 'primary.main', backgroundColor: theme => primarySoft(theme, 0.06), color: 'primary.main' },
            }}
          >
            {field.NAME}
          </Button>
        ))}
      </Box>
    </>
  );
}

export default PersonalFieldButtons;
